new Swiper(".testimonialSwiper", {
  slidesPerView: 1.2,
  spaceBetween: 20,
  watchOverflow: false,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".pagintestimonial",
    clickable: true,
  },
  navigation: {
    nextEl: ".testimonial-next",
    prevEl: ".testimonial-prev",
  },
  breakpoints: {
    375: { slidesPerView: 1.5, spaceBetween: 24 },
    420: { slidesPerView: 1.5, spaceBetween: 24 },
    768: { slidesPerView: 2.5, spaceBetween: 24 },
    1024: { slidesPerView: 3, spaceBetween: 30 },
    1280: { slidesPerView: 4, spaceBetween: 32 },
    1440: { slidesPerView: 4, spaceBetween: 32 }
  },
});

var swipercustom = new Swiper(".custom-gallery-swiper", {
  effect: "coverflow",
  loop: true,
  grabCursor: true,
  centeredSlides: true,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 2.5
  },
   navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
  keyboard: {
    enabled: true
  },
 
  spaceBetween: 30,
  loop: true,
  breakpoints: {
    640: {
      slidesPerView: 2
    },
    1024: {
      slidesPerView: 3
    }
  }
});

